import voluntaryFA from './fa/fa.json'

const VoluntaryMessages = {
  fa: { ...voluntaryFA },
}

export default VoluntaryMessages
